module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACHSURBVHgB5ZA9DkAwGIbfT2MwcAAkrsFsZXVRjuAUFolwAgmLhKpFpNV25UmaJm3e5/sBfkKU5eJIcLThMC0BqgDmyb5JGyan4HVqTG1jJzAIqwWG4RP5DshdxL1v7yNymPR1HnoEydlfCT8izGNnJ7gknYlELXhKgnjlkt5OcJeAbWK073EABPEq2TmEBXQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/onboarding-chevron.png
// module id = 207
// module chunks = 0